// Geboortevenster · Detail van één blok (floating panel): waarde, exacte van-tot, oorzaken en de knop om de kandidaattijd daar te zetten.
// Overzicht van de feature: EgituraPlatform/docs/human-design/hd-birth-window.md

import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { FLOATING_PANEL_DATA } from '@shared/floating-panel/floating-panel-data.token';
import { FLOATING_PANEL_REF } from '@shared/floating-panel/floating-panel-ref.token';
import { HdBirthWindowStateService } from './hd-birth-window-state.service';

export interface HdBirthWindowBlockPopupCause {
  readonly glyph: string;
  readonly planet: string;
  readonly side: string;
  readonly from: string;
  readonly to: string;
}

/** Vooraf gerenderde teksten: het paneel kent taal, zone en labels; de popup toont enkel. */
export interface HdBirthWindowBlockPopupData {
  readonly propertyLabel: string;
  readonly valueLabel: string;
  readonly stateLabel: string;
  readonly state: 'birth' | 'same' | 'different';
  readonly fromText: string;
  readonly toText: string;
  readonly durationText: string;
  readonly utcText: string;
  readonly causesLabel: string;
  readonly causes: readonly HdBirthWindowBlockPopupCause[];
  readonly noCauseText: string;
  readonly setTimeLabel: string;
  /** Moment dat "Zet geboortetijd hier" kiest (begin van het blok, of de geboorte zelf op het geboorteblok). */
  readonly setTimeMs: number | undefined;
  readonly fromLabel: string;
  readonly toLabel: string;
  readonly durationLabel: string;
}

/**
 * Detail van één blok in het geboortevenster (klik, zoals de transit-blokken):
 * waarde, exacte van-tot op de geboorteklok en in UTC, duur, wat er op het
 * beginmoment wisselt, en de knop om de kandidaattijd daar te zetten.
 */
@Component({
  selector: 'hd-birth-window-block-popup',
  imports: [SharedModule],
  templateUrl: './hd-birth-window-block-popup.component.html',
  styleUrl: './hd-birth-window-block-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdBirthWindowBlockPopupComponent {
  private readonly panelData = inject(FLOATING_PANEL_DATA) as Signal<HdBirthWindowBlockPopupData>;
  private readonly panelRef = inject(FLOATING_PANEL_REF, { optional: true }) as { close(): void } | null;
  private readonly state = inject(HdBirthWindowStateService);

  protected readonly data = computed(() => this.panelData());

  protected setTimeHere(): void {
    const ms = this.data().setTimeMs;
    if (ms === undefined) return;
    this.state.candidateMs.set(ms);
    this.state.requestHandlers()?.previewAt(ms);
    this.panelRef?.close();
  }
}
